"use client";

import { IconDisabledBackwardArrow, IconForwardArrow } from "@repo/assets/images";
import cx from "classnames";
const CarouselButton = ({
  direction,
  children,
  className,
  variant = "carousel",
  ...restProps
}) => {
  const isPrev = direction === "prev";
  return <button className={cx("disabled:border-lightgray group p-1 disabled:bg-white", {
    "text-supportiveBlack hover:bg-lightbrown border border-[#DDD9D6]": variant === "product",
    "rounded-full": variant === "carousel"
  }, className)} type="button" aria-label={direction} {...restProps} data-sentry-component="CarouselButton" data-sentry-source-file="CarouselButton.jsx">
      <IconForwardArrow className={cx({
      "group-disabled:hidden": true,
      "fill-current": variant === "carousel",
      // LTR: prev = left (-180), next = right (0)
      // RTL: prev = right (0), next = left (180)
      "-rotate-180 rtl:rotate-0": isPrev,
      "rotate-0 rtl:rotate-180": !isPrev
    })} data-sentry-element="IconForwardArrow" data-sentry-source-file="CarouselButton.jsx" />
      <IconDisabledBackwardArrow className={cx("hidden group-disabled:block", {
      "fill-current": variant === "carousel",
      // Match orientation with active icon
      "-rotate-180 rtl:rotate-0": !isPrev,
      "rotate-0 rtl:rotate-180": isPrev
    })} data-sentry-element="IconDisabledBackwardArrow" data-sentry-source-file="CarouselButton.jsx" />
      {children}
    </button>;
};
export default CarouselButton;